import Phone from '!!@svgr/webpack!@nrdy-marketing-engine/components/svg/phone.svg';

export default function HotmathTitle() {
  return (
    <>
      <div className="hidden dark:xl:block container-xl sticky top-navbar-height z-[9]">
        <div className="absolute top-0 right-0 text-sm shadow-md">
          <div className="bg-[#ffd670] py-1 px-12">We&lsquo;re Open - Call Now!</div>
          <div className="bg-[#007ac0] text-white py-2 px-12 rounded-b">
            <Phone className="float-left -ml-8 mt-2" />
            <div>Call Now to Set Up Tutoring</div>
            <div className="font-bold">(888) 736-0920</div>
          </div>
        </div>
      </div>
      <div className="bg-slate-200 py-8 md:py-12 xl:py-18 flex dark:bg-[#adaead] dark:text-white">
        <a className="mx-auto px-4 text-center" href="/hotmath">
          <span className="text-4xl font-semibold mb-3 block dark:font-normal dark:text-5xl">
            Hotmath
          </span>
          <span className="text-2xl block">Math Homework. Do It Faster, Learn It Better.</span>
        </a>
      </div>
    </>
  );
}
